module.exports = __webpack_public_path__ + "static/media/d4ru.aba00d8f.pdf";